import { render, staticRenderFns } from "./autoSignApply.vue?vue&type=template&id=5a4b50c2&scoped=true&"
import script from "./autoSignApply.vue?vue&type=script&lang=js&"
export * from "./autoSignApply.vue?vue&type=script&lang=js&"
import style0 from "./autoSignApply.vue?vue&type=style&index=0&id=5a4b50c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4b50c2",
  null
  
)

export default component.exports